<div class="Main">
  <div class="container-fluid mt-3">
    <div class="d-flex bd-highlight align-items-center gap-3 flex-wrap">
      <div class="p-2 flex-grow-2 bd-highlight d-flex flex-wrap gap-2">
        <button class="head_btn" (click)="listName = 'over'">Overall</button>
        <button
          class="head_btn"
          *ngIf="roleCode == 'SA'"
          (click)="getAbstract('oversna')"
        >
          Overall SNA
        </button>
        <button class="head_btn" (click)="dayWise()">Day Wise</button>
        <button class="head_btn" (click)="getAbstract('agency')">
          Requisitioning Body Wise
        </button>
        <button class="head_btn" (click)="getAbstract('district')">
          District Wise
        </button>
      </div>
      <div class="p-2 bd-highlight d-flex flex-wrap align-items-center gap-2">
        <!-- Year Dropdown -->
        <!-- <label for="year" class="me-1">Select Year:</label>
        <select
          id="year"
          class="year_filter"
          [(ngModel)]="selectedYearD"
          (change)="onYearChange($event.target.value)"
        >
          <option *ngFor="let year of years" [value]="year">{{ year }}</option>
        </select>

        <label for="month" class="me-1">Select Month:</label>
        <select
          id="month"
          class="month_filter"
          [(ngModel)]="selectedMonthD"
          (change)="onMonthChange($event.target.value)"
        >
          <option *ngFor="let month of months" [value]="month.value">
            {{ month.name }}
          </option>
        </select>

       

        <label>Select Week:</label>
        <select
          [(ngModel)]="selectedWeekIndex"
          (change)="onWeekChange(selectedWeekIndex)"
        >
          <option [ngValue]="'all'">All</option>
          <option
            *ngFor="let i of [].constructor(5); let index = index"
            [ngValue]="index"
            [disabled]="index >= weekCount"
          >
            {{ index + 1 }}
          </option>
        </select>

       
        <button
          class="btn btn-primary"
          [disabled]="!selectedWeekD"
          (click)="search('search')"
        >
          Search
        </button>
        &nbsp;
        <button
          class="btn btn-danger"
          [disabled]="!selectedWeekD"
          (click)="search()"
        >
          clear
        </button> -->

        <!-- Year months and week -->
        <label for="year">Year:</label>
<select id="year" [(ngModel)]="selectedYear" (change)="onYearChange($event.target.value)">
  <option [value]="null">-- Select Year --</option>
  <option *ngFor="let year of years" [value]="year">{{ year }}</option>
</select>

<label for="month">Month:</label>
<select id="month" [(ngModel)]="selectedMonth" (change)="onMonthChange($event.target.value)">
  <option *ngFor="let month of months" [value]="month.value">{{ month.name }}</option>
</select>

<label for="week">Week:</label>
<select id="week" [(ngModel)]="selectedWeekIndex" (change)="onWeekChange(selectedWeekIndex)">
  <option *ngFor="let week of weeks; let i = index" [ngValue]="i">
    {{ i === 0 ? 'All' : 'Week ' + i }}
  </option>
</select>

<button class="btn btn-primary" [disabled]="!selectedYear" (click)="search('search')">Search</button>
<button class="btn btn-danger" [disabled]="!selectedYear" (click)="search('clear')">Clear</button>


        <!-- end of clear button  -->

        <!-- radio button for croce or rupees -->

        <label>
          <input
            type="radio"
            name="unit"
            [checked]="selectedUnit === 'Crore'"
            (change)="onUnitChange('Crore')"
          />
          in Crore
        </label>

        <label>
          <input
            type="radio"
            name="unit"
            [checked]="selectedUnit === 'Rupees'"
            (change)="onUnitChange('Rupees')"
          />
          in Rupees
        </label>
      </div>
    </div>

    <!-- card Section -->
    <div *ngIf="listName == 'over'">
      <div class="card top">
        <!-- projet section [part 1] nothing change -->
        <div class="row g-xl-3">
          <!-- part 1  -->

          <div class="col-lg-3">
            <div
              class="card list1"
              style="cursor: pointer"
              (click)="noOfProject()"
            >
              <div class="row">
                <div class="col-lg-6 bl1">
                  <p>Total No. of Projects</p>
                  <h3>{{ this.fundDtails?.noOfProjects }}</h3>
                </div>
                <div class="col-lg-6">
                  <img
                    src="../../../assets/img/Background.png"
                    style="float: right"
                    alt=""
                  />
                </div>
                <p class="mt-2">
                  <span class="increase"
                    >{{ this.fundDtails?.noOfProjectsOnLastMonth }} </span
                  >Last Month
                </p>
              </div>
            </div>
          </div>
          <!-- Fund Receive section  [part 2] chages happen-->
          <div class="col-lg-3">
            <div
              class="card list2"
              style="cursor: pointer"
              (click)="fund('receive')"
            >
              <div class="row">
                <div class="col-lg-8 bl2">
                  <p>Fund Received ({{ selectedUnit }})</p>
                  <h3>
                    {{
                      this.fundDtails?.totalFundReceived
                        | currencyUnit : selectedUnit
                    }}
                  </h3>
                </div>
                <div class="col-lg-4">
                  <img
                    src="../../../assets/img/Background (1).png"
                    style="float: right"
                    alt=""
                  />
                </div>
                <p class="mt-2">
                  <span class="increase">
                    {{
                      this.fundDtails?.fundReceivedOnLastMonth
                        | currencyUnit : selectedUnit
                    }}
                  </span>
                  From last Month
                </p>
              </div>
            </div>
          </div>
          <!-- Expenditure   [part 3] chages happen-->
          <div class="col-lg-3">
            <div
              class="card list3"
              style="cursor: pointer"
              (click)="expenditure()"
            >
              <div class="row">
                <div class="col-lg-8 bl3">
                  <p>Expenditure({{ selectedUnit }})</p>
                  <h3>
                    {{
                      this.fundDtails?.totalFundSpent
                        | currencyUnit : selectedUnit
                    }}
                  </h3>
                </div>
                <div class="col-lg-4">
                  <img
                    src="../../../assets/img/Background (2).png"
                    style="float: right"
                    alt=""
                  />
                </div>
                <p class="mt-2">
                  <span class="increase">
                    {{
                      this.fundDtails?.expenditureOnLastMonth
                        | currencyUnit : selectedUnit
                    }} </span
                  >From last Month
                </p>
              </div>
            </div>
          </div>
          <!-- Balance   [part 4] chages happen-->
          <div class="col-lg-3">
            <div class="card list4" (click)="fund('balance')">
              <div class="row">
                <div class="col-lg-8 bl4">
                  <p>Closing Balance({{ selectedUnit }})</p>
                  <h3>
                    {{
                      this.fundDtails?.totalAvailableAmount
                        | currencyUnit : selectedUnit
                    }}
                  </h3>
                </div>
                <div class="col-lg-4">
                  <img
                    src="../../../assets/img/Overlay.png"
                    style="float: right"
                    alt=""
                  />
                </div>
                <p class="mt-2">
                  <span class="increase">
                    {{
                      this.fundDtails?.balanceOnLastMonth
                        | currencyUnit : selectedUnit
                    }}
                  </span>
                  From last Month
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- chart section -->
      <div class="row mt-1 g-xl-2">
        <div class="col-lg-4">
          <div class="card p-3">
            <h2 class="head">Districts vs No of Beneficiaries</h2>
            <div style="height: 400px; overflow-y: auto">
              <highcharts-chart
                [Highcharts]="Highcharts"
                [options]="districtHighChart"
                [style]="{
                  width: '100%',
                  minHeight: districtchartHeight,
                  display: 'block'
                }"
              ></highcharts-chart>
            </div>
            <!-- <div id="chart">
              <apx-chart *ngIf="isShowFirstChart" [series]="chartOption.series" [chart]="chartOption.chart"
                [dataLabels]="chartOption.dataLabels" [plotOptions]="chartOption.plotOptions"
                [xaxis]="chartOption.xaxis" [stroke]="chartOption.stroke" [fill]="chartOption.fill"
                [yaxis]="chartOption.yaxis" [title]="chartOption.title" [tooltip]="chartOption.tooltip"
                [legend]="chartOption.legend"></apx-chart>
            </div> -->
            <!-- <canvasjs-chart *ngIf="isShowFirstChart" [options]="chartOptions"
              [styles]="{width: '100%', height:'360px'}"></canvasjs-chart> -->
          </div>
        </div>
        <div class="col-lg-4">
          <div class="month" style="height: 470px">
            <h2 class="head mt-2">
              Month Wise Expenditure Made (Rs. in Crore)
            </h2>
            <highcharts-chart
              [Highcharts]="Highcharts"
              [options]="chartOptionsMonthWise"
              style="width: 100%; height: 400px; display: block"
            ></highcharts-chart>
            <!-- <p-chart type="line" height="370px" [data]="data" [options]="options"></p-chart> -->
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card p-3" style="height: 470px">
            <h2 class="head">Fund Shortage Details (Rs. in Crore)</h2>
            <div class="table-container">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Project</th>
                    <th scope="col">Available Amount</th>
                    <th scope="col">Available Percentage</th>
                  </tr>
                </thead>
              </table>
              <div class="table-scroll-body">
                <table class="table">
                  <tbody>
                    <tr *ngFor="let data of fundShortageDetails">
                      <td>{{ data.projectName }}</td>
                      <td style="text-align: center">
                        {{ data.availableAmount | croreTwoDecimal }}
                      </td>
                      <td style="text-align: center">
                        {{ data.availablePercent.toFixed(2) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="text-center" *ngIf="fundShortageDetails == ''">
              <img
                src="../../../assets/img/notFound.png"
                width="350px"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <!-- 2nd row -->

      <!-- old code for 2row in block wise -->

      <!--      <div class="row mt-1 g-xl-2">
        <div class="col-lg-4">
          <div class="card p-3">
            <h2 class="head">Fund Details (Rs. in Crore)</h2>
            
            <div style="width: 100%; overflow-x: auto">
              <div style="min-width: 1500px; width: 100%; height: 400px;">
                <highcharts-chart
                  [Highcharts]="Highcharts"
                  [options]="fundDetailsHighChart"
                  style="width: 100%; height: 400px; display: block"
                ></highcharts-chart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card p-3">
            <h2 class="head">Disbursement Details (Rs. in Crore)</h2>
            
            <figure class="highcharts-figure">
              <highcharts-chart
                [Highcharts]="Highcharts"
                [options]="chartOptionsHigh"
                style="width: 100%; height: 400px; display: block"
              ></highcharts-chart>
            </figure>
            <div class="text-center" *ngIf="disbursementDetails == ''">
              <img
                src="../../../assets/img/notFound.png"
                width="350px"
                alt=""
              />
            </div>
          </div>
        </div>
      </div> -->

      <!-- new code for updated 2 block for Fund details in crore -->

      <div class="row mt-1 g-xl-2">
        <!-- Fund Details Block Now Occupies 8 Columns -->
        <div class="col-lg-8">
          <div class="card p-3">
            <h2 class="head">Request Body wise Fund Details (Rs. in Crore)</h2>
            <div style="width: 100%; overflow-x: auto">
              <div style="min-width: 1500px; width: 100%; height: 400px">
                <highcharts-chart
                  [Highcharts]="Highcharts"
                  [options]="fundDetailsHighChart"
                  style="width: 100%; height: 400px; display: block"
                ></highcharts-chart>
              </div>
            </div>
          </div>
        </div>

        <!-- Disbursement Details Block Remains 4 Columns -->
        <div class="col-lg-4">
          <div class="card p-3">
            <h2 class="head">Disbursement Details (Rs. in Crore)</h2>
            <figure class="highcharts-figure">
              <highcharts-chart
                [Highcharts]="Highcharts"
                [options]="chartOptionsHigh"
                style="width: 100%; height: 400px; display: block"
              ></highcharts-chart>
            </figure>
            <div class="text-center" *ngIf="disbursementDetails == ''">
              <img
                src="../../../assets/img/notFound.png"
                width="350px"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <!-- end of block chart section -->
    </div>
    <!-- dialog Box section -->
    <div *ngIf="listName == 'over'">
      <!-- card 1 -->
       <!-- Agency Expenditure List -->
      <!-- <p-dialog
        header="Agency Expenditure List"
        [modal]="true"
        [(visible)]="visible"
        [style]="{ width: '25rem' }"
      >

        <table class="table">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Expenditure</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of agencyDetails">
              <td>{{ data.name }}</td>
              <td>{{ data.expenditure | currencyUnit : selectedUnit }}</td>
            </tr>
          </tbody>
        </table>

      </p-dialog> -->
      <!-- part 1 -->
       
    <!--   <p-dialog
        header="No of Projects"
        [modal]="true"
        [(visible)]="noOfProjects"
        [style]="{ width: '100rem' }"
      >
        <div class="row">
          
          <div class="col-lg-6">
           <button class="btn btn-primary mb-2" (click)="downloadPDF1()">Download PDF</button>

          <div #pdfContent>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Name of the Requesting body</th>
                  <th scope="col">Number of Projects</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of getNoOfProjects; let i = index">
                  <td>
                    {{ data.agencyName }}
                  </td>
                  <td>
                    <span class="count" (click)="getData(i)">{{
                      data.totalNoOfProjects
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td>Total</td>
                  <td>{{ totalcount }}</td>
                </tr>
              </tbody>
            </table>
            
          </div>
          </div>
          <div class="col-lg-6">
            <div class="card p-1">
              <p-chart
                type="pie"
                *ngIf="showPie"
                [data]="dataforPie"
                width="400px"
                [options]="optionsforPie"
              ></p-chart>
            </div>
            <div class="mt-3">
              <table class="table" *ngIf="selectProject">
                <thead>
                  <tr>
                    <th scope="col">Project Name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of selectProject">
                    <td>{{ data.name }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </p-dialog> -->


      <p-dialog
  header="No of Projects"
  [modal]="true"
  [(visible)]="noOfProjects"
  [contentStyle]="{ overflow: 'auto' }"
  (onHide)="resetDialog()"
>
  <div [ngStyle]="{ width: dialogWidth }">
    <div class="row">
      <!-- Left Section -->
      <div [ngClass]="layoutFullWidth ? 'col-lg-12' : 'col-lg-6'">
        <button class="btn btn-primary mb-2" (click)="downloadPDF1()">Download Projects PDF</button>

        <div #pdfContent>
          <table class="table">
            <thead>
              <tr>
                <th>Name of the Requisitioning body</th>
                <th>Number of Projects</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of getNoOfProjects; let i = index">
                <td>{{ data.agencyName }}</td>
                <td>
                  <span class="count" (click)="getData(i)">
                    {{ data.totalNoOfProjects }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>Total</td>
                <td>{{ totalcount }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Right Section: Pie Chart + Table -->
      <div class="col-lg-6" *ngIf="!layoutFullWidth">
        <div class="card p-1">
          <p-chart
            type="pie"
            [data]="dataforPie"
            width="400px"
            [options]="optionsforPie"
          ></p-chart>
        </div>

        <div class="mt-3">
          <table class="table" *ngIf="selectProject">
            <thead>
              <tr>
                <th>Project Name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of selectProject">
                <td>{{ data.name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</p-dialog>


      <!-- Card 2 -->

      <p-dialog
        header="{{ flag == 'receive' ? 'Fund Received' : 'Fund Balance' }}"
        [modal]="true"
        [(visible)]="isFundReceived"
        [style]="{ width: '65rem' }"
      >
        <div class="row">
          <!--        <div class="p-2 bd-highlight">
          <p-calendar
              dateFormat="dd-mm-yy"
              [(ngModel)]="popupFromDate"
              placeholder="From Date"
              styleClass="datepicker"
            ></p-calendar>
            <p-calendar
              dateFormat="dd-mm-yy"
              [minDate]="fromDate"
              [(ngModel)]="popuptoDate"
              class="mx-2"
              placeholder="To Date"
              styleClass="datepicker"
            ></p-calendar>
            <button
              class="btn btn-primary"
              *ngIf="flag == 'receive'"
              [disabled]="popupFromDate == '' || popuptoDate == ''"
              (click)="fund('receive', 'filter')"
            >
              Search
            </button>
            &nbsp;
            <button
              class="btn btn-danger"
              *ngIf="flag == 'receive'"
              [disabled]="popupFromDate == '' || popuptoDate == ''"
              (click)="fund('receive')"
            >
              clear
            </button>
            <button
              class="btn btn-primary"
              *ngIf="flag == 'balance'"
              [disabled]="popupFromDate == '' || popuptoDate == ''"
              (click)="fund('balance', 'filter')"
            >
              Search
            </button>
            &nbsp;
            <button
              class="btn btn-danger"
              *ngIf="flag == 'balance'"
              [disabled]="popupFromDate == '' || popuptoDate == ''"
              (click)="fund('balance')"
            >
              clear
            </button>  
          </div>
          -->

          <!-- updated new year, months, week -->
          <div
            class="p-2 bd-highlight d-flex flex-wrap align-items-center gap-2"
          >
                    <!-- Year months and week -->
        <label for="year">Year:</label>
<select id="year" [(ngModel)]="selectedYear" (change)="onYearChange($event.target.value)">
  <option [value]="null">-- Select Year --</option>
  <option *ngFor="let year of years" [value]="year">{{ year }}</option>
</select>

<label for="month">Month:</label>
<select id="month" [(ngModel)]="selectedMonth" (change)="onMonthChange($event.target.value)">
  <option *ngFor="let month of months" [value]="month.value">{{ month.name }}</option>
</select>

<label for="week">Week:</label>
<select id="week" [(ngModel)]="selectedWeekIndex" (change)="onWeekChange(selectedWeekIndex)">
  <option *ngFor="let week of weeks; let i = index" [ngValue]="i">
    {{ i === 0 ? 'All' : 'Week ' + i }}
  </option>
</select>

<button class="btn btn-primary" [disabled]="!selectedYear" (click)="search('search')">Search</button>
<button class="btn btn-danger" [disabled]="!selectedYear" (click)="search('clear')">Clear</button>


            <!-- download button -->
            <!-- <div [innerHTML]="generateButtonHtml(flag)"></div> -->

            <button
  class="btn btn-primary"
  (click)="downloadPDF('receive')"
  *ngIf="flag === 'receive'"
>
  Download Fund Received PDF
</button>

<button
  class="btn btn-primary"
  (click)="downloadPDF('balance')"
  *ngIf="flag === 'balance'"
>
  Download Fund Balance PDF
</button>


          </div>

          <div [id]="flag === 'receive' ? 'fund-receive-pdf' : 'fund-balance-pdf'">
  <!-- Wrap only this section for PDF export -->

  <!-- fund received -->
          <p-table
  [value]="fundReceivedData"
  dataKey="agencyId"
  [expandedRowKeys]="expandedRows"
  (onRowCollapse)="onRowCollapse($event)"
  (onRowExpand)="onRowExpand($event)"
  [tableStyle]="{ 'min-width': '60rem' }"
  styleClass="excel-table"
>
  <ng-template pTemplate="header">
    <tr>
      <th class="thead" style="width: 5rem"></th>
      <th class="thead">Name of the Requisitioning body</th>
      <th class="thead">Number of Projects</th>
      <th class="thead">Fund Received</th>
      <th class="thead" *ngIf="flag == 'balance'">Fund Disbursed</th>
      <th class="thead" *ngIf="flag == 'balance'">Balance Fund Available</th>
    </tr>
  </ng-template>

  <ng-template
    pTemplate="body"
    let-fund
    let-expanded="expanded"
    let-index="rowIndex"
  >
    <tr>
      <td>
        <button
          pButton
          severity="secondary"
          type="button"
          [pRowToggler]="fund"
          text="true"
          rounded="true"
          plain="true"
          [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
        ></button>
      </td>
      <td>{{ fund.agencyName }}</td>
      <td>{{ fund.noOfProjects }}</td>
      <td>
        {{ fund.fundReceivedForAgency | currencyUnit : selectedUnit }}
      </td>
      <td *ngIf="flag == 'balance'">
        {{ fund.fundDisbursedByAgency | currencyUnit : selectedUnit }}
      </td>
      <td *ngIf="flag == 'balance'">
        {{ fund.balanceAvailable | currencyUnit : selectedUnit }}
      </td>
    </tr>

    <tr *ngIf="index == fundReceivedDataLength">
      <td class="bg text-center" colspan="2">Total</td>
      <td class="bg">{{ noProject }}</td>
      <td class="bg">
        {{ totalAmountReceived | currencyUnit : selectedUnit }}
      </td>
      <td class="bg" *ngIf="flag == 'balance'">
        {{ amountDisburse | currencyUnit : selectedUnit }}
      </td>
      <td class="bg" *ngIf="flag == 'balance'">
        {{ amountBalance | currencyUnit : selectedUnit }}
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="rowexpansion" let-fund>
    <tr>
      <td colspan="9">
        <div class="p-3">
          <p-table
            [value]="fund.projects"
            dataKey="projectId"
            styleClass="excel-table"
          >
            <ng-template pTemplate="header">
              <tr>
                <th class="thead1">S. No</th>
                <th class="thead1">Name of the Requisitioning Body</th>
                <th class="thead1">Name of Project</th>
                <th class="thead1">District</th>
                <th class="thead1">Fund Received</th>
                <th class="thead1" *ngIf="flag == 'balance'">Fund Spent</th>
                <th class="thead1" *ngIf="flag == 'balance'">Fund Balance</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-order let-i="rowIndex">
              <tr>
                <td>{{ i + 1 }}</td>
                <td>{{ order.agencyName }}</td>
                <td (mouseover)="over(order)">
                  <span
                    pTooltip="{{ tooltipContent }}"
                    tooltipPosition="top"
                  >
                    {{ order.projectName }}
                  </span>
                </td>
                <td>
                  <ng-container *ngFor="let d of order.districts">
                    {{ d.name }}<br />
                  </ng-container>
                </td>
                <td>{{ order.fundReceived | currencyUnit : selectedUnit }}</td>
                <td *ngIf="flag == 'balance'">
                  {{ order.fundSpent | currencyUnit : selectedUnit }}
                </td>
                <td *ngIf="flag == 'balance'">
                  {{ order.fundBalance | currencyUnit : selectedUnit }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

            <!-- wrap end here -->
</div>
        </div>
      </p-dialog>

      <!-- card 3 -->
       <!-- Fund Expenditure -->
      <p-dialog
        header="FUND EXPENDITURE"
        [modal]="true"
        [(visible)]="isFundExpenditure"
        [style]="{ width: '90rem' }"
      >
        <div class="row">

  
          <!-- <div class="p-2 bd-highlight">
            <p-calendar
              dateFormat="dd-mm-yy"
              [(ngModel)]="popupExpenditurefromDate"
              placeholder="From Date"
              styleClass="datepicker"
            ></p-calendar>
            <p-calendar
              dateFormat="dd-mm-yy"
              [minDate]="fromDate"
              [(ngModel)]="popupExpendituretoDate"
              class="mx-2"
              placeholder="To Date"
              styleClass="datepicker"
            ></p-calendar>
            <button
              class="btn btn-primary"
              [disabled]="
                popupExpenditurefromDate == '' || popupExpendituretoDate == ''
              "
              (click)="expenditure('filter')"
            >
              Search
            </button>
            &nbsp;
            <button
              class="btn btn-danger"
              [disabled]="
                popupExpenditurefromDate == '' || popupExpendituretoDate == ''
              "
              (click)="expenditure()"
            >
              clear
            </button> 

          </div> -->

          <!-- updated new year, months, week -->
          <div
            class="p-2 bd-highlight d-flex flex-wrap align-items-center gap-2"
          >
                    <!-- Year months and week -->
        <label for="year">Year:</label>
<select id="year" [(ngModel)]="selectedYear" (change)="onYearChange($event.target.value)">
  <option [value]="null">-- Select Year --</option>
  <option *ngFor="let year of years" [value]="year">{{ year }}</option>
</select>

<label for="month">Month:</label>
<select id="month" [(ngModel)]="selectedMonth" (change)="onMonthChange($event.target.value)">
  <option *ngFor="let month of months" [value]="month.value">{{ month.name }}</option>
</select>

<label for="week">Week:</label>
<select id="week" [(ngModel)]="selectedWeekIndex" (change)="onWeekChange(selectedWeekIndex)">
  <option *ngFor="let week of weeks; let i = index" [ngValue]="i">
    {{ i === 0 ? 'All' : 'Week ' + i }}
  </option>
</select>

<button class="btn btn-primary" [disabled]="!selectedYear" (click)="search('search')">Search</button>
<button class="btn btn-danger" [disabled]="!selectedYear" (click)="search('clear')">Clear</button>

            <!-- download option card 3 -->
             <button class="btn btn-primary" (click)="downloadPDF2()">Download Fund Expenditure PDF</button>

          

          </div>




<div #pdfContent id="pdf-content">

          <p-tabView [(activeIndex)]="activeIndex">
            <p-tabPanel header="Requisitioning Body Wise">
              <table class="table expenditure-data" >
                <thead>
                  <tr>
                    <th scope="col">Name of the Requisitioning Body</th>
                    <th scope="col">Total No of Projects</th>
                    <th scope="col">Total Fund Received</th>
                    <th scope="col">No of Projects Disbursement Done</th>
                    <th scope="col">Expenditure</th>
                    <th scope="col">Balance Fund</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let data of expenditureList?.requestioningBody
                        .requestioningBodyAbstract
                    "
                  >
                    <td>
                      <span
                        class="highlight"
                        (click)="getDrillDown(data, 'agency')"
                        >{{ data?.agencyName }}</span
                      >
                    </td>
                    <td>{{ data?.noOfProjects }}</td>
                    <td>
                      {{
                        data?.totalAmountReceived | currencyUnit : selectedUnit
                      }}
                    </td>
                    <td>{{ data?.noOfProjectsDonePayment }}</td>
                    <td>
                      {{ data?.totalAmountSpent | currencyUnit : selectedUnit }}
                    </td>
                    <td>
                      {{ data?.totalBalance | currencyUnit : selectedUnit }}
                    </td>
                  </tr>
                  <tr class="bg">
                    <td>Total</td>
                    <td>
                      {{ expenditureList?.requestioningBody.totalNoOfProjects }}
                    </td>
                    <td>
                      {{
                        expenditureList?.requestioningBody.totalFundReceived
                          | currencyUnit : selectedUnit
                      }}
                    </td>
                    <td>
                      {{
                        expenditureList?.requestioningBody
                          .totalProjectsDisbursementDone
                      }}
                    </td>
                    <td>
                      {{
                        expenditureList?.requestioningBody.totalFundSpent
                          | currencyUnit : selectedUnit
                      }}
                    </td>
                    <td>
                      {{
                        expenditureList?.requestioningBody.totalFundBalance
                          | currencyUnit : selectedUnit
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </p-tabPanel>
            <p-tabPanel header="District Wise">
              <table class="table district expenditure-data">
                <thead>
                  <tr>
                    <th scope="col">District Name</th>
                    <th scope="col">Total No of Projects</th>
                    <th scope="col">Total Fund Received</th>
                    <!-- <th scope="col">No of Projects Disbursement Done</th> -->
                    <th scope="col">Expenditure</th>
                    <!-- <th scope="col">Balance</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let data of expenditureList?.district.districtAbstract
                    "
                  >
                    <td>
                      <span
                        class="highlight"
                        (click)="getDrillDown(data, 'district')"
                        >{{ data?.districtName }}</span
                      >
                    </td>
                    <td>{{ data?.noOfProjects }}</td>
                    <td>{{data?.totalAmountReceived | croreTwoDecimal}}</td>
                    <!-- <td>{{ data?.noOfProjectsDonePayment }}</td> -->
                    <td>
                      {{ data?.totalAmountSpent | currencyUnit : selectedUnit }}
                    </td>
                    <!-- <td>{{data?.totalBalanceAmount |croreTwoDecimal}}</td> -->
                  </tr>
                  <tr class="bg">
                    <td>Total</td>
                    <td></td>
                    <td></td>
                    <td>
                      {{
                        expenditureList?.district.totalFundSpent
                          | currencyUnit : selectedUnit
                      }}
                    </td>
                    <!-- <td>
                </td> -->
                  </tr>
                </tbody>
              </table>
            </p-tabPanel>
          </p-tabView>
          <!-- wrapper end here  -->
          </div>
        </div>
      </p-dialog>
      <p-dialog
  [header]="'Project Details' + (dialogType === 'district' ? ' (' + clickedName + ')' : '')"
  [modal]="true"
  [(visible)]="agencyPopup"
  [style]="{ width: 'auto' }"
>

        <!-- [style]="{ width: 'auto' or width: '80 rem' }" adjust to update expenditure size-->
        <div class="sticky-table-container">
          <table class="table table-bordered Expenditure-border">
            <thead>
              <tr>
                <th rowspan="2">S.No
                  <br>
                  <small>1</small>
                </th>
                <!-- <th rowspan="2" *ngIf="dialogType === 'agency'">Name of the Project</th> -->
                <th rowspan="2" >Name of the Project
                  <br>
                  <small>2</small>
                </th>
                <th rowspan="2">Total Fund Received
                  <br>
                  <small>3</small>
                </th>
                <!-- <th rowspan="2" *ngIf="dialogType === 'agency'">Project Extent</th> -->
                <th rowspan="2" >Project Extent
                  <br>
                  <small>4</small>
                </th>
                <th rowspan="2">Extent for which Award Passed
                  <br>
                  <small>5</small>
                </th>
                <th rowspan="2">No. of Beneficiaries entered in SNA Portal
                  <br>
                  <small>6</small>
                </th>
                <th rowspan="2" class="text-center">Total No. of Survey Number as per Award
                  <br>
                  <small>7</small>
                </th>
                <th colspan="5" class="text-center">Disbursement Details
                </th>
                <!-- <th rowspan="2">Total Disbursement</th> -->
                <th colspan="2" class="text-center">Balance
                </th>
                <!-- <th rowspan="2">% Beneficiary Pay</th> -->
                <th rowspan="2">
                  Percentage of Beneficiaries received payment
                  <br>
                  <small>15</small>
                </th>
                <!-- <th rowspan="2">% Court Pay</th> -->
                <th rowspan="2">
                  Percentage of beneficiaries where amount is deposited in Court
                  <br>
                  <small>16</small>
                </th>
              </tr>
              <tr>
                <!-- <th>Amount Spent Beneficiary</th> -->
                <th>Amount Disbursed to Beneficiaries
                  <br>
                  <small>8</small>
                </th>
                <!-- <th>No of Beneficiary Award</th> -->
                <th>No. of Beneficiaries issued Payment
                  <br>
                  <small>9</small>
                </th>
                <!-- <th>Court Pay</th> -->
                <th>Amount Deposited in Court
                  <br>
                  <small>10</small>
                </th>
                <!-- <th>No of Court Beneficiary</th> -->
                <th>No. of Beneficiaries issued to Court Deposit
                  <br>
                  <small>11</small>
                </th>
                <th>Total Funds Disbursed (8 + 10)
                  <br>
                  <small>12</small>
                </th>
                <!-- <th>Pending Beneficiary</th> -->
                <th>No of beneficiaries for Pending action
                  <br>
                  <small>13</small>
                </th>
                <!-- <th>Balance Amount</th> -->
                <th>Balance Funds Available
                  <br>
                  <small>14</small>
                </th>
              </tr>

        <!-- <th *ngFor="let col of columnCountArray; let j = index" style="font-weight: bold;">
          {{ j + 1 }}
        </th> -->
            </thead>
            <tbody>
              <!-- fix district section to 14 other wise 16 -->

              <tr *ngFor="let data of agencyList; let i = index">
                <td style="font-weight: bold;">{{ i + 1 }}</td>
                <!-- <td *ngIf="dialogType === 'agency'">{{ data.projectName }}</td> -->
                 <td>{{ data.projectName }}</td>
                <td>{{ data.fundReceived | currencyUnit : selectedUnit }}</td>
                <!-- <td *ngIf="dialogType === 'agency'">{{ data.pendingExtent }}</td> -->
                <td>{{ data.pendingExtent }}</td>
                <td>{{ data.acquiredExtent }}</td>
                <td>{{ data.noOfBeneficiaries }}</td>
                <td>{{ data.noOfSubDivisionsAwarded }}</td>
                <td class="color-data1">
                  {{ data.amountDisbursedToBeneficiary }}
                </td>
                <td class="color-data1">{{ data.noOfBeneficiariesAwarded }}</td>
                <td class="color-data1">{{ data.amountDisbursedInCourt }}</td>
                <td class="color-data1">
                  {{ data.noOfBeneficiariesInCourtDeposit }}
                </td>
                <td class="color-data1">{{ data.totalFundDisbursed }}</td>
                <td class="color-data2">{{ data.noOfPendingBeneficiaries }}</td>
                <td class="color-data2">
                  {{ data.balanceFundsAvailable | currencyUnit : selectedUnit }}
                </td>
                <td>{{ data.percentOfBeneficariesAwarded }}</td>
                <td>{{ data.percentOfBeneficairiesInCourtDeposit }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </p-dialog>
    </div>
    <div *ngIf="listName == 'oversna'" class="container">
      <table class="table overallSNA">
        <thead>
          <tr>
            <th colspan="2" scope="col">
              <h2 class="text-center m-0">Overall Abstract of SNA</h2>
            </th>
          </tr>
        </thead>
        <tbody class="text-center">
          <tr>
            <th scope="row" class="p-4">Total No of Projects</th>
            <td class="p-4">{{ overallSNA?.noOfProjects }}</td>
          </tr>
          <tr>
            <th scope="row" class="p-4">Total Amount Received</th>
            <td class="p-4">
              {{
                overallSNA?.totalAmountReceived | currencyUnit : selectedUnit
              }}
            </td>
          </tr>
          <tr>
            <th scope="row" class="p-4">Interest Amount</th>
            <td class="p-4">
              {{ overallSNA?.interestAmount | currencyUnit : selectedUnit }}
            </td>
          </tr>
          <tr>
            <th scope="row" class="p-4 table-info">
              Total Amount Value in SNA
            </th>
            <td class="table-info p-4">
              {{ overallSNA?.totalAmount | currencyUnit : selectedUnit }}
            </td>
          </tr>
          <tr>
            <th scope="row" class="p-4">
              Compensation Disbursed to Beneficiaries
            </th>
            <td class="p-4">
              {{
                overallSNA?.compensationToBeneficiaries
                  | currencyUnit : selectedUnit
              }}
            </td>
          </tr>
          <tr>
            <th scope="row" class="p-4">
              Compensation Deposited in court through SNA
            </th>
            <td class="p-4">
              {{
                overallSNA?.compensationToCourt | currencyUnit : selectedUnit
              }}
            </td>
          </tr>
          <tr>
            <th scope="row" class="p-4">Compensation Returned</th>
            <td class="p-4">
              {{
                overallSNA?.compensationReturned | currencyUnit : selectedUnit
              }}
            </td>
          </tr>
          <tr>
            <th scope="row" class="p-4 table-success">
              Total Compensation spent through SNA
            </th>
            <td class="table-success p-4">
              {{ overallSNA?.totalSpent | currencyUnit : selectedUnit }}
            </td>
          </tr>
          <tr>
            <th scope="row" class="p-4 table-danger">
              Total Balance Amount Available
            </th>
            <td class="table-danger p-4">
              {{ overallSNA?.totalBalance | currencyUnit : selectedUnit }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="listName == 'agency'" class="container">
      <h2>Requisitioning Body Wise Abstract</h2>
      <div class="bgFilter">
        <p-multiSelect
          [options]="agencyListForFilter"
          [(ngModel)]="agencyFilter"
          optionLabel="agencyName"
          selectedItemsLabel="{0} agencies selected"
          [style]="{ minWidth: '100px' }"
          showClear="true"
          placeholder="Select Agency"
        ></p-multiSelect>
        &nbsp;
        <button class="btn btn-primary" (click)="changeValue('agency')">
          Submit</button
        >&nbsp;
        <button class="btn btn-danger" (click)="getAbstract('agency')">
          Clear
        </button>
      </div>
      <div class="tableForAgency">
        <p-table
  [value]="agencyListAbstract"
  dataKey="agencyId"
  [expandedRowKeys]="expandedRows"
  (onRowCollapse)="onRowCollapse($event)"
  (onRowExpand)="onRowExpand($event)"
  [tableStyle]="{ 'min-width': '70rem' }"
  styleClass="excel-table"
>
  <!-- Header Template -->
  <ng-template pTemplate="header">
    <tr class="thead">
      <th class="thead" style="width: 5rem"></th>
      <th class="thead">Name of Requisitioning Body</th>
      <th class="thead">No. of Projects</th>
      <th class="thead">No. of Districts</th>
      <th class="thead">
        No. of Beneficiaries
        <br />
        <small>(Beneficiaries/Count)</small>
      </th>
      <th class="thead">
        Amount Disbursed
        <br />
        <small>(Beneficiaries/Count)</small>
      </th>
    </tr>
  </ng-template>

  <!-- Body Template -->
  <ng-template pTemplate="body" let-fund let-expanded="expanded">
    <tr>
      <td>
        <button
          pButton
          type="button"
          [pRowToggler]="fund"
          class="btnForExpand"
          text="true"
          rounded="true"
          plain="true"
          [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
        ></button>
      </td>
      <td>{{ fund.agencyName }}</td>
      <td>{{ fund.noOfProjects }}</td>
      <td>{{ fund.noOfDistricts }}</td>
      <td>{{ fund.noOfBeneficiaries }}</td>
      <td>{{ fund.amountDisbursed | currencyUnit : selectedUnit }}</td>
    </tr>
  </ng-template>

  <!-- Row Expansion Template -->
  <ng-template pTemplate="rowexpansion" let-fund>
    <tr>
      <td colspan="6">
        <div class="p-3">
          <p-table [value]="fund.projects" dataKey="projectId">
            <ng-template pTemplate="header">
              <tr>
                <th class="thead">#</th>
                <th class="thead">Project Name</th>
                <!-- <th class="thead">No of Districts</th> -->
                <th class="thead">District</th>
                <th class="thead">No. of Beneficiaries
                  <br>
                  <small>Beneficiaries/Court</small>
                </th>
                <th class="thead">Amount Disbursed
                  <br>
                  <small>Beneficiaries/Court</small>
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-order let-i="rowIndex">
              <tr>
                <td>{{ i + 1 }}</td>
                <td>{{ order.projectName }}</td>
                <!-- <td>{{ order.noOfDistricts }}</td> -->
                <td>
  <ng-container *ngFor="let d of order.districts">
    {{ d.name }}<br />
  </ng-container>
</td> 
                <td>{{ order.noOfBeneficiaries }}</td>
                <td>{{ order.fundSpent | currencyUnit : selectedUnit }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

      </div>
    </div>
    <div *ngIf="listName == 'day'" class="container-fluid">
      <h2>Day Wise Abstract</h2>
      <div>
        <div class="table-wrapper">
          <table class="table daywise-table">
            <thead>
              <tr>
                <th rowspan="2">Month & Year</th>
                <ng-container *ngFor="let agency of agencyNames">
                  <th colspan="2">{{ agency }}</th>
                </ng-container>
                <th colspan="2">Total</th>
              </tr>
              <tr>
                <ng-container *ngFor="let agency of agencyNames">
                  <th>No of Projects</th>
                  <th>Amount</th>
                </ng-container>
                <th>No of Projects</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let entry of disbursementData">
                <td>{{ entry.disbursementDate | date : "dd-MM-yyyy" }}</td>
                <ng-container *ngFor="let agency of agencyNames">
                  <td class="letterBg" (click)="getAgency(entry, agency)">
                    {{ getProjectsByAgency(entry.agencies, agency) || "-" }}
                  </td>
                  <td>
                    {{
                      getAmountByAgency(entry.agencies, agency)
                        ? (getAmountByAgency(entry.agencies, agency)
                          | currencyUnit : selectedUnit)
                        : "-"
                    }}
                  </td>
                </ng-container>
                <td>{{ entry.totalNoOfProjects }}</td>
                <td>{{ entry.amountSpent | currencyUnit : selectedUnit }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <p-dialog
        header="Day Wise Abstract"
        [modal]="true"
        [(visible)]="dayWiseAbstarct"
        [style]="{ width: '100rem' }"
      >
        <div class="row">
          <div class="col-lg-6">
            <h2>Beneficiary List</h2>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Name of the Project</th>
                  <th scope="col">Name of the Beneficiary</th>
                  <th scope="col">Name of the District</th>
                  <th scope="col">Amount Spent</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let data of courtList?.beneficiaryList; let i = index"
                >
                  <td>{{ data.projectName }}</td>
                  <th>{{ data.beneficiaryName }}</th>
                  <td>{{ data.districtName }}</td>
                  <td>
                    {{
                      data.amountSpentToBeneficiary
                        | currencyUnit : selectedUnit
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-lg-6">
            <h2>Court Deposit List</h2>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Name of the Project</th>
                  <th scope="col">Name of the District</th>
                  <th scope="col">Court Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of courtList?.courtList; let i = index">
                  <td>{{ data.projectName }}</td>
                  <td>{{ data.districtName }}</td>
                  <td>{{ data.courtAmount | currencyUnit : selectedUnit }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </p-dialog>
    </div>
    <div *ngIf="listName == 'district'" class="container">
      <h2>District Wise Abstract</h2>
      <div class="bgFilter">
        <p-multiSelect
          [options]="districtListForFilter"
          [(ngModel)]="districtFilter"
          optionLabel="name"
          selectedItemsLabel="{0} districts selected"
          [style]="{ minWidth: '100px' }"
          showClear="true"
          placeholder="Select District"
        ></p-multiSelect>
        &nbsp;
        <button class="btn btn-primary" (click)="changeValue('district')">
          Submit</button
        >&nbsp;
        <button class="btn btn-danger" (click)="getAbstract('district')">
          Clear
        </button>
      </div>
      <div class="tableForAgency">
        <p-table
  [value]="districtListAbstract"
  dataKey="districtId"
  [expandedRowKeys]="expandedRows"
  (onRowCollapse)="onRowCollapse($event)"
  (onRowExpand)="onRowExpand($event)"
  [tableStyle]="{ 'min-width': '70rem' }"
  styleClass="excel-table"
>
  <ng-template pTemplate="header">
    <tr class="thead">
      <th class="thead" style="width: 3rem"></th>        
      <!-- <th class="thead" style="width: 4rem">S. No</th>  -->
      <th class="thead">Name of the District</th>
      <th class="thead">Number of Projects</th>
      <th class="thead">Number of Beneficiary</th>
      <th class="thead">No. of Requisitioning Body</th>
      <th class="thead">Amount Disbursed<br>
        <small>(Beneficiaries/Court)</small>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-fund let-expanded="expanded" let-i="rowIndex">
    <tr>
      <td>
        <button
          pButton
          type="button"
          class="btnForExpand"
          [pRowToggler]="fund"
          text="true"
          rounded="true"
          plain="true"
          [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
        ></button>
      </td>
      <!-- <td>{{ i + 1 }}</td>  -->
      <td>{{ fund.districtName }}</td>
      <td>{{ fund.noOfProjects }}</td>
      <td>{{ fund.noOfBeneficiariesAwarded }}</td>
      <td>{{ fund.noOfAgencies }}</td>
      <td>{{ fund.amountDisbursed | currencyUnit : selectedUnit }}</td>
    </tr>
  </ng-template>

  <ng-template pTemplate="rowexpansion" let-fund>
    <tr>
      <td colspan="20">
        <div class="p-3">
          <p-table
            [value]="fund.drillDown"
            dataKey="agencyId"
            styleClass="bordered-table"
          >
            <ng-template pTemplate="header">
              <tr>
                <th class="thead1" style="width: 4rem">S. No</th>
                <th class="thead1">Name of the Requisitioning Body</th>
                <th class="thead1">Name of the Project</th>
                <th class="thead1">No. of beneficiaries<br>
                  <small>(Beneficiaries/Court)</small>
                </th>
                <th class="thead1">Amount Disbursed<br>
                  <small>(Beneficiaries/Court)</small>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-order let-rowIndex="rowIndex">
              <tr>
                <td>{{ rowIndex + 1 }}</td> <!-- Serial number -->
                <td>{{ order.agencyName }}</td>
                <td>{{ order.projectName }}</td>
                <td>{{ order.noOfBeneficiariesAwarded }}</td>
                <td>{{ order.amountDisbursedByAgency | currencyUnit : selectedUnit }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

      </div>
    </div>
  </div>
</div>
